import {UIService} from "../UIService";
import {ProductDataService} from "../../services/productDataService";
import {ProductDataStore} from "../../stores/productDataStore";
import {GlazingPackageService} from "./glazingPackageService";
import {EventService} from "../../services/eventService";
import {AppStateService} from "../../services/appStateService";
import {ErrorReportingService} from "../../services/errorReportingService";

export class GlazingPackageUIService {
    private uiService: UIService;
    private productDataService: ProductDataService;
    private productDataStore: ProductDataStore;
    private glazingPackageService: GlazingPackageService;
    private eventService: EventService;
    private appStateService: AppStateService;
    private errorReportingService: ErrorReportingService;

    constructor() {
        this.uiService = new UIService();
        this.productDataService = new ProductDataService();
        this.productDataStore = new ProductDataStore();
        this.glazingPackageService = new GlazingPackageService();
        this.eventService = new EventService();
        this.appStateService = new AppStateService();
        this.errorReportingService = new ErrorReportingService();
    }

    public initializeGlazingPackageComponent()
    {
        this.initializeGlazingSpacers();
        this.initializeResetButton();
        this.redirectToNewGlazingPackage();
        this.populatePreview();

        this.eventService.getTarget().addEventListener('sizeChange', (data) => {
            this.refreshPrices();
        });
    }

    private populatePreview()
    {
        const previewGlazingPackage = this.uiService.getElementByActionName('preview-glazingPackage');
        const previewGlazingSpacer = this.uiService.getElementByActionName('preview-glazingSpacer');

        // const selectedGlazingPackage = this.productDataStore.getSelectedOption(
        //     'glazingPackage',
        //     'glazingPackages',
        // );
        const selectedGlazingSpacerId = this.productDataStore.getSelectedOptionIdByName('glazingSpacers');
        const allGlazingPackages = this.productDataStore.getAvailableOptionsByName(
            'glazing'
        );
        const allGlazingSpacers = this.productDataStore.getAvailableOptionsByName(
            'glazingSpacers'
        );

        previewGlazingPackage.forEach((element) => {
            this.uiService.removeHtmlInElement(element);
        });
        previewGlazingSpacer.forEach((element) => {
            this.uiService.removeHtmlInElement(element);
        });

        allGlazingPackages.some((glazingPackage) => {
            if (this.productDataStore.getSelectedOptionIdByName('glazing') === glazingPackage.id) {
                const element = document.createElement('p');
                element.appendChild(
                        document.createTextNode(
                            glazingPackage.attributes.name
                        )
                    );

                previewGlazingPackage.forEach((previewGlazingPackageElement) => {
                    previewGlazingPackageElement.append(element);
                });



                return true;
            }
        });
        if (selectedGlazingSpacerId !== null) {
            allGlazingSpacers.some((glazingSpacer) => {
                if (selectedGlazingSpacerId === glazingSpacer.id) {
                    const element = document.createElement('p');
                    element.appendChild(
                            document.createTextNode(
                                glazingSpacer.name
                            )
                        );

                    previewGlazingSpacer.forEach((previewGlazingSpacerElement) => {
                        previewGlazingSpacerElement.append(element);
                    });

                    this.uiService.replaceTextInElement(
                        this.uiService.getElementByAttribute(
                            'nf-value-key',
                            'selectedGlazingSpacerName'
                        ),
                        glazingSpacer.name
                    );
                    this.uiService.replaceTextInElement(
                        this.uiService.getElementByAttribute(
                            'nf-value-key',
                            'selectedGlazingSpacerPrice'
                        ),
                        glazingSpacer.price
                    );

                    return true;
                }
            });
        }
    }

    private initializeResetButton()
    {
        const resetButton = this.uiService.getResetButtonByModule('glazingSpacer');

        if (resetButton !== null) {
            resetButton.addEventListener(
                'click',
                this.glazingPackageService.resetSelectedOptions.bind(
                    this
                )
            );
        }
    }

    private redirectToNewGlazingPackage()
    {
        const glazingOptions = this.uiService.getElementsByAttribute('nf-template-action', 'switchGlazing');

        glazingOptions.forEach((glazingOption) => {
            glazingOption.addEventListener('click', (event: any) => {
                const url = event.currentTarget.getAttribute('nf-option-id');
                if (url) {
                    const hingeOptionSelector: any = this.uiService.getElementByAttribute('nf-template-input', 'productHingeSideOption');
                    localStorage.setItem('shape', JSON.stringify({
                        height: Math.floor(this.productDataStore.getAttributeByName('height')),
                        width: Math.floor(this.productDataStore.getAttributeByName('width')),
                        bottomPanel: this.productDataStore.getAttributeByName('bottomPanel'),
                        unit: this.productDataStore.getSelectedOptionIdByName('unit'),
                        hingeSide: this.productDataStore.getSelectedOptionIdByName(
                            this.uiService.getAttributeFromElement(hingeOptionSelector, 'nf-option-name')
                        ),
                    }));

                    localStorage.setItem('relationship', JSON.stringify(
                        this.productDataStore.getAllSelectedOptions()
                    ));
                    window.location.href = url;
                }
            });
        });
    }

    private initializeGlazingSpacers()
    {
        const glazingSpacers = this.productDataStore.getAvailableOptionsByName('glazingSpacers');

        if (glazingSpacers.length > 0) {
            glazingSpacers.forEach((glazingSpacer) => {
                const option = this.createGlazingSpacerOption(glazingSpacer);
                if (glazingSpacer.id === this.productDataStore.getSelectedOptionIdByName('glazingSpacers')) {
                    this.uiService.setSelectedOption(option);
                }

                option.addEventListener('click', (event: any) => {
                    this.productDataService.updateSelectedOptionByName('glazingSpacers', glazingSpacer.id, true);
                    this.uiService.resetSelectionsByPartName('glazingSpacer');
                    this.uiService.setSelectedOption(event.currentTarget);
                    this.populatePreview();
                });
            });
        } else {
            this.appStateService.setAppSettingTemplateFlag('glazingPackages', 'glazingSpacerContainer', false);
            this.uiService.refreshElementsInModule('glazingPackages');
        }
    }

    private createGlazingSpacerOption(glazingSpacer)
    {
        const option = this.uiService.createConfiguratorOption('glazingSpacer');

        this.uiService.setAttributeToElement(
            option,
            'nf-option-id',
            glazingSpacer.id
        );
        var imageName = glazingSpacer.image_3_glass;
        const selectedGlazing = this.productDataStore.getSelectedOptionData('glazing');
        const numberOfChambers = (selectedGlazing) ? selectedGlazing.attributes.chambers : 1;
        
        if (numberOfChambers === 1) {
            imageName = glazingSpacer.image_2_glass;
        }
        const image = '/files/glazingspacers/' + imageName;
        const price = this.glazingPackageService.getGlazingSpacerPrice(glazingSpacer.priceAfterDiscount);
        const spacerType = (glazingSpacer.type === this.glazingPackageService.aluminiumSpacer) ? 'Aluminium' : 'Warm';

        if (imageName !== null) {
            this.uiService.setAttributeToElement(
                option.querySelector('[nf-value-key="icon"]'),
                'src',
                image
            );
        } else {
            this.uiService.hideElement(option.querySelector('[nf-value-key="icon"]'));
            this.uiService.setBackgroundColorToElement(option.querySelector('.configuratorOptionCircleListingItem__icon'), glazingSpacer.hex);
        }

        this.uiService.addTextInElement(
            option.querySelector('[nf-value-key="info"]'),
            spacerType
        );

        this.uiService.setAttributeToElement(
            option,
            'nf-option-id',
            glazingSpacer.id
        );

        this.uiService.addTextInElement(
            option.querySelector('[nf-value-key="title"]'),
            glazingSpacer.name
        );

        this.uiService.addTextInElement(
            option.querySelector('[nf-value-key="price"]'),
            price
        );

        return option;
    }

    private refreshPrices()
    {
        const glazingSpacers = this.uiService.getElementsByPartName('glazingSpacer');

        glazingSpacers.forEach((glazingSpacerOption) => {
            const glazingSpacerId: any = glazingSpacerOption.getAttribute('nf-option-id');
            const glazingSpacer = this.productDataStore.getAvailableOptionByNameAndId('glazingSpacers', glazingSpacerId);
            const price = this.glazingPackageService.getGlazingSpacerPrice(glazingSpacer.priceAfterDiscount);
            const priceElement = glazingSpacerOption.querySelector('[nf-value-key="price"]');

            if (priceElement !== null) {
                this.uiService.replaceTextInElement(
                    priceElement,
                    price
                );
            } else {
                this.errorReportingService.display(`Price element on glazing spacer #${glazingSpacerId} is missing.`);
            }
        });
    }
}
